require("!!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/script-loader/addScript.js")(require("!!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/raw-loader/index.js!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/bower_components/clipboard/dist/clipboard.js"))


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/script-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/bower_components/clipboard/dist/clipboard.js
// module id = 30
// module chunks = 2